import { Component, createRef } from "react";
import i18next from "../../locale/i18n";

type ActiveTool = 'cut' | 'sew' | 'unfold' | null;

interface SidePanelState {
    activeTool: ActiveTool;
}

export class SidePanel extends Component<{}, SidePanelState> {
    toolCutButton: React.RefObject<HTMLButtonElement>;
    toolSewButton: React.RefObject<HTMLButtonElement>;
    toolUnfoldButton: React.RefObject<HTMLButtonElement>;

    public state: SidePanelState = {
        activeTool: null
    };

    constructor(props: {}) {
        super(props);
        this.toolCutButton = createRef<HTMLButtonElement>();
        this.toolSewButton = createRef<HTMLButtonElement>();
        this.toolUnfoldButton = createRef<HTMLButtonElement>();
    }

    // These methods are kept for backwards compatibility but do nothing now
    setEdgeSeams(_: number) {}
    setGlobalStretchness(_: number) {}
    setGoal(_: number | null, __: number | null) {}

    setActiveTool(tool: ActiveTool) {
        this.setState({ activeTool: tool });
    }

    getToolButtonClass(tool: ActiveTool): string {
        return this.state.activeTool === tool ? 'btnPrimary btnActive' : 'btnPrimary';
    }

    render() {
        const t = (key: string) => i18next.t(key);

        return (
            <div id="ToolSidepanel" className="sidepanel">
                <div id="ToolsMenu">
                    <h1 id="ToolTitle">{t('practice:tools')}</h1>
                    <div id="ToolsContent">
                        <div className="btnSpan">
                            <button
                                className={this.getToolButtonClass('cut')}
                                id="ToolCut"
                                ref={this.toolCutButton}
                            >
                                {t('practice:cut')}
                            </button>
                            <span className="desktopOnly">{t('practice:keyHint')} : <b>X</b></span>
                        </div>
                        <div className="btnSpan">
                            <button
                                className={this.getToolButtonClass('sew')}
                                id="ToolSew"
                                ref={this.toolSewButton}
                            >
                                {t('practice:sew')}
                            </button>
                            <span className="desktopOnly">{t('practice:keyHint')} : <b>C</b></span>
                        </div>
                        <div className="btnSpan">
                            <button
                                className={this.getToolButtonClass('unfold')}
                                id="ToolUnfold"
                                ref={this.toolUnfoldButton}
                            >
                                {t('practice:unfold')}
                            </button>
                            <span className="desktopOnly">{t('practice:keyHint')} : <b>V</b></span>
                        </div>
                        <span className="desktopOnly hint-text">
                            {t('practice:shiftHint')}
                        </span>
                        <span className="desktopOnly hint-text">
                            {t('practice:resetHint')}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}
